<template>
  <div class="detail-container">
    <h1 class="page-title">建物マスタ情報詳細</h1>
    <div v-if="building">
      <div v-if="building.m_customer">
        <table class="table table-bordered">
          <tr>
            <th>ID</th>
            <td>{{ building.id }}</td>
          </tr>
          <tr>
            <th>顧客名</th>
            <td class="multiline-text">{{ building.m_customer.customer_nm }}</td>
          </tr>
          <tr>
            <th>区分</th>
            <td>{{ building.m_building_type.building_type_nm }}</td>
          </tr>
          <tr>
            <th>建物名</th>
            <td>{{ building.building_nm }}</td>
          </tr>
          <tr>
            <th>所在地</th>
            <td>〒{{ building.postal_code }} {{building.prefecture}}{{building.city}}{{building.other_address}}</td>
          </tr>
          <tr>
            <th>電話番号</th>
            <td>{{ building.tel_num }}</td>
          </tr>
          <tr>
            <th>契約日</th>
            <td>{{ building.contract_dt }}</td>
          </tr>
          <tr>
            <th>担当者</th>
            <td>{{ building.in_charge_nm }}</td>
          </tr>
          <tr>
            <th>携帯番号</th>
            <td>{{ building.in_charge_phone_num }}</td>
          </tr>
          <tr>
            <th>担当者メールアドレス</th>
            <td>{{ building.in_charge_email }}</td>
          </tr>
          <tr>
            <th>定額請求</th>
            <td>
              {{
                {
                  true: "対象",
                  false: "",
                }[building.fixed_fee_billing]
              }}
            </td>
          </tr>
          <tr>
            <th>社内担当者</th>
            <td>{{ building.internal_person.name }}</td>
          </tr>
          <tr>
            <th>契約終了日</th>
            <td>{{ building.contract_end_dt }}</td>
          </tr>
          <tr>
            <th class="btn-cell">年間予定作業</th>
            <td class="btn-cell">
              <!-- 昨年度ボタン -->
              <router-link
                v-if="prevFiscal(building.contract_dt)"
                :to="{ name: 'AnnualWorkScheduleList', params: { building_id: building.id, start_month: prevFiscal(building.contract_dt).start } }">
                <button type="button" class="btn btn-success mx-1 my-1">
                  {{ prevFiscal(building.contract_dt).label }}
                </button>
              </router-link>

              <!-- 今年度ボタン -->
              <router-link
                v-if="currentFiscal(building.contract_dt)"
                :to="{ name: 'AnnualWorkScheduleList', params: { building_id: building.id, start_month: currentFiscal(building.contract_dt).start }, query: route.query }">
                <button type="button" class="btn btn-warning mx-1 my-1">
                  {{ currentFiscal(building.contract_dt).label }}
                </button>
              </router-link>

              <!-- 来年度ボタン -->
              <router-link
                v-if="nextFiscal(building.contract_dt)"
                :to="{ name: 'AnnualWorkScheduleList', params: { building_id: building.id, start_month: nextFiscal(building.contract_dt).start }, query: route.query }">
                <button type="button" class="btn btn-info mx-1 my-1">
                  {{ nextFiscal(building.contract_dt).label }}
                </button>
              </router-link>
            </td>
          </tr>
        </table>

        <div class="btn-area">
          <router-link :to="{ name: 'BuildingList', params: { id: building.id }, query: route.query }"> <!-- 顧客情報編集ページへのリンク -->
            <button type="button" class="btn btn-primary">一覧へ</button>
          </router-link>

          <router-link v-if="userRole == 0 || userRole == 999" :to="{ name: 'BuildingEdit', params: { id: building.id }, query: route.query }"> <!-- 顧客情報編集ページへのリンク -->
            <button type="button" class="btn btn-success mx-2">編集</button>
          </router-link>
        </div>
      </div>
      <div v-else>
        顧客情報情報を読み込み中...
      </div>
    </div>
    <!-- その他の詳細情報 -->
    <div v-else>
      建物情報情報を読み込み中...
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { getBuilding } from '@/api/axios';

export default {
  setup() {
    const title = ref('建物情報詳細');

    watchEffect(() => {
      document.title = title.value;
    });

    const store = useStore();
    const route = useRoute();
    const userRole = computed(() => store.state.userRole);
    const building = ref({});
    const buildingId = route.params.id;

    const fetchBuilding = async () => {
      const response = await getBuilding(buildingId);
      building.value = response.data;
    };

    // 年度別の取得関数
    const prevFiscal = (date) => getFiscalYearRange(date, -1);
    const currentFiscal = (date) => getFiscalYearRange(date, 0);
    const nextFiscal = (date) => getFiscalYearRange(date, 1);

    // 汎用の年度範囲関数（共通ロジック）
    const getFiscalYearRange = (contractDate, offset = 0) => {
      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth() + 1;
      const contractMonth = contractDate ? new Date(contractDate).getMonth() + 1 : 1;

      const startYear = contractMonth <= currentMonth ? currentYear + offset : currentYear + offset - 1;

      const startMonth = new Date(startYear, contractMonth - 1);
      const endMonth = new Date(startYear + 1, contractMonth - 2); // 翌年の契約月の前月

      return {
        start: `${startMonth.getFullYear()}-${startMonth.getMonth() + 1}-${startMonth.getDate()}`,
        end: endMonth,
        label: `${startMonth.getFullYear()}年${startMonth.getMonth() + 1}月〜${endMonth.getFullYear()}年${endMonth.getMonth() + 1}月`
      };
    };

    onMounted(fetchBuilding);

    return {
      title,
      userRole,
      building,
      prevFiscal,
      currentFiscal,
      nextFiscal,
      route
    };
  }
};
</script>
